import { AjaxError } from '@/services';
import { showToast } from '@/store';
import {
  ErrorResponse
} from "@/types";

export const handleHttpError = async (err: unknown, shouldShowToast: boolean = true): Promise<string> => {
  if (err instanceof AjaxError && err.response) {
    try {
      const errorResponse = await err.response.json() as ErrorResponse;
      const errorMessage = errorResponse.data.error || "Errore sconosciuto";
      
      if (shouldShowToast) {
        showToast(errorMessage, 'Si è verificato un errore', 'error');
      }
      
      return errorMessage;
    } catch (jsonError) {
      const fallbackMessage = "Errore sconosciuto durante l'elaborazione della risposta.";
      
      if (shouldShowToast) {
        showToast(fallbackMessage, '', 'error');
      }
      
      return fallbackMessage;
    }
  } else if (err instanceof Error) {
    const errorMessage = `Errore: ${err.message}`;
    
    if (shouldShowToast) {
      showToast(errorMessage, '', 'error');
    }
    
    return errorMessage;
  } else {
    const unknownError = 'Errore sconosciuto.';
  
    if (shouldShowToast) {
      showToast(unknownError, '', 'error');
    }
    
    return unknownError;
  }
};
